import { Component, Input, OnInit } from '@angular/core';
import { RoutingAuthenticationService } from '../../services/routing-authentication';
import { InformationProvider } from '../../providers/information.provider';

@Component({
    moduleId: module.id,
    selector: 'page-link',
    templateUrl: 'page-link.component.html',
})
export class PageLink implements OnInit{

    @Input() page: string;
    @Input() link: string;
    className: string;

    get allowed() {
        return !!this.routerAuth.allowedPages[this.page];
    }

    constructor(private routerAuth: RoutingAuthenticationService, private infoProvider: InformationProvider) {

        this.infoProvider.onCurrentUrlChange.subscribe(url => {

            if(!url || !this.link) return;
            
            if (this.areEqual(url, this.link)) {
                this.className = "sub-item selected-link";
            }
            else {
                this.className = "sub-item";
            }
        });

    }

    async ngOnInit(){

        await this.routerAuth.init();
    }

    areEqual(a, b) {
        
        if (a[0] == '/') a = a.substr(1);
        if (b[0] == '/') b = b.substr(1);

        a = a.split('/');
        b = b.split('/');

        return a[0] == b[0] && a[1] == b[1];
    }



}




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/PageLink/page-link.component.ts